// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"572":"8ba3a0","748":"11f069"}[chunkId] + ".js";
};